var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"-8.94559e-08","y1":"9.65942","x2":"16","y2":"9.65942","stroke":"#1A1D31","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M7.2 18.4776L16.0958 11.233C17.0785 10.4326 17.0785 8.93171 16.0958 8.13138L7.2 0.886718","stroke":"#1A1D31","strokeWidth":"1.8","key":1})]);
}

Arrow.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
